import React from 'react'
import {Icon} from '@chakra-ui/react'

const WebsiteIcon = (props) => {
    return (
        <Icon viewBox="0 0 16 16" {...props}>
            <path
                d="M8 0.583008C12.0959 0.583184 15.4159 3.90411 15.416 8C15.4158 12.0959 12.0959 15.4158 8 15.416C3.90411 15.4159 0.583184 12.0959 0.583008 8C0.58314 3.90408 3.90408 0.58314 8 0.583008ZM2.13281 8.75C2.42715 11.0753 4.06901 12.9792 6.25293 13.6533C5.30584 12.188 4.73984 10.5026 4.61328 8.75H2.13281ZM11.3857 8.75C11.2593 10.5027 10.694 12.188 9.74707 13.6533C11.9309 12.9793 13.5729 11.0753 13.8672 8.75H11.3857ZM6.11523 8.75C6.26216 10.4914 6.91739 12.1514 7.99902 13.5225C9.08107 12.1512 9.73772 10.4916 9.88477 8.75H6.11523ZM6.25195 2.3457C4.06845 3.02011 2.42717 4.925 2.13281 7.25H4.61328C4.73986 5.49735 5.3049 3.81109 6.25195 2.3457ZM7.99902 2.47656C6.9172 3.84771 6.26217 5.50842 6.11523 7.25H9.88477C9.73771 5.50826 9.08115 3.84784 7.99902 2.47656ZM9.74805 2.3457C10.6949 3.81111 11.2593 5.4973 11.3857 7.25H13.8672C13.5729 4.92494 11.9315 3.02009 9.74805 2.3457Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default WebsiteIcon
